<template>
  <div class="page-container">
    <el-card class="page-content" shadow="never">
      <div class="page-actions">
        <div class="select">
          <div class="item">
            <el-input
              v-model.trim="account"
              size="small"
              clearable
              placeholder="请输入用户名"
              @keyup.enter.native="handleSearch"
            ></el-input>
          </div>
          <div class="item">
            <el-button size="small" type="primary" @click="handleSearch"
              >查询</el-button
            >
          </div>
          <div class="item">
            <el-button size="small" type="primary" @click="openCreate"
              >新增</el-button
            >
          </div>
        </div>
      </div>
      <el-table :data="tabList" height="calc(100vh - 360px)" size="small">
        <el-table-column prop="account" label="用户名"></el-table-column>
        <el-table-column label="是否绑定谷歌">
          <template slot-scope="scope">
            <span>{{ scope.row.googleBound ? "是" : "否" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" width="420">
          <template slot-scope="scope">
            <div class="btnsFlex">
              <el-button size="mini" @click="openEdit(scope.row)">编辑</el-button>
              <el-button size="mini" @click="toggleLock(scope.row)">{{
                scope.row.isLocked ? "启用" : "禁用"
              }}</el-button>
              <el-button size="mini" type="danger" @click="remove(scope.row)"
                >删除</el-button
              >
              <el-button size="mini" type="primary" @click="openReset(scope.row)"
                >重置密码</el-button
              >
              <el-button
                size="mini"
                type="danger"
                @click="removeGoogle(scope.row)"
                >删除谷歌</el-button
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
      <Pagination
        :size="pagination.size"
        :total="totalCount"
        :page="pagination.page"
        @pageChanged="paginationHandle"
      ></Pagination>

      <el-dialog
        :title="formTitle"
        :visible.sync="dialogVisible"
        width="420px"
        :close-on-click-modal="false"
        @close="closeFormDialog"
      >
        <el-form ref="formRef" :model="formData" label-width="90px">
          <input
            type="text"
            style="position: absolute; left: -9999px; width: 1px; height: 1px"
            autocomplete="username"
          />
          <input
            type="password"
            style="position: absolute; left: -9999px; width: 1px; height: 1px"
            autocomplete="new-password"
          />
          <el-form-item
            label="用户名"
            prop="account"
            :rules="[
              { required: true, message: '请输入用户名', trigger: 'blur' },
            ]"
          >
            <el-input
              v-model.trim="formData.account"
              autocomplete="off"
              name="system-user-account"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="密码"
            prop="password"
            :rules="[
              { required: true, message: '请输入密码', trigger: 'blur' },
            ]"
          >
            <el-input
              v-model.trim="formData.password"
              type="password"
              show-password
              autocomplete="new-password"
              name="system-user-password"
            ></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer">
          <el-button @click="closeFormDialog">取消</el-button>
          <el-button type="primary" @click="submitForm">确定</el-button>
        </div>
      </el-dialog>

      <el-dialog
        title="重置密码"
        :visible.sync="resetDialogVisible"
        width="420px"
        :close-on-click-modal="false"
        @close="closeResetDialog"
      >
        <el-form ref="resetFormRef" :model="resetData" label-width="90px">
          <input
            type="password"
            style="position: absolute; left: -9999px; width: 1px; height: 1px"
            autocomplete="new-password"
          />
          <el-form-item label="用户名">
            <span>{{ resetData.account || "-" }}</span>
          </el-form-item>
          <el-form-item
            label="新密码"
            prop="password"
            :rules="[
              { required: true, message: '请输入新密码', trigger: 'blur' },
            ]"
          >
            <el-input
              v-model.trim="resetData.password"
              type="password"
              show-password
              autocomplete="new-password"
              name="system-user-reset-password"
            ></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer">
          <el-button @click="closeResetDialog">取消</el-button>
          <el-button type="primary" @click="submitReset">确定</el-button>
        </div>
      </el-dialog>

      <el-dialog
        title="谷歌验证码"
        :visible.sync="googleDialogVisible"
        width="320px"
        :close-on-click-modal="false"
        @close="closeGoogleDialog"
      >
        <el-form ref="googleFormRef" :model="googleForm" label-width="100px">
          <el-form-item
            label="谷歌验证码"
            prop="googleCode"
            :rules="[
              {
                required: true,
                message: '请输入谷歌验证码',
                trigger: 'blur',
              },
            ]"
          >
            <el-input
              v-model.trim="googleForm.googleCode"
              autocomplete="off"
              name="system-user-google-code"
            ></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer">
          <el-button @click="closeGoogleDialog">取消</el-button>
          <el-button type="primary" @click="confirmGoogle">确定</el-button>
        </div>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
import Pagination from "components/pagination";
import encrypt from "@/utils/encrypt";
import api from "./api";

export default {
  components: {
    Pagination,
  },
  data() {
    return {
      account: "",
      tabList: [],
      totalCount: 0,
      pagination: {
        page: 1,
        size: 25,
      },
      dialogVisible: false,
      formTitle: "新增",
      formData: {
        id: "",
        account: "",
        password: "",
      },
      resetDialogVisible: false,
      resetData: {
        id: "",
        account: "",
        password: "",
      },
      googleDialogVisible: false,
      googleForm: {
        googleCode: "",
      },
      pendingAction: null,
    };
  },
  mounted() {
    this.fetchList();
  },
  methods: {
    fetchList() {
      api
        .list({
          account: this.account,
          ...this.pagination,
        })
        .then((res) => {
          if (res.code == 0) {
            const data = res.data || {};
            this.tabList = data.list || [];
            this.totalCount = data.totalCount || 0;
          }
        });
    },
    handleSearch() {
      this.pagination.page = 1;
      this.fetchList();
    },
    paginationHandle(pagination) {
      this.pagination = pagination;
      this.fetchList();
    },
    openCreate() {
      this.formTitle = "新增";
      this.formData = {
        id: "",
        account: "",
        password: "",
      };
      this.dialogVisible = true;
    },
    openEdit(row) {
      this.formTitle = "编辑";
      this.formData = {
        id: row.id,
        account: row.account || "",
        password: "",
      };
      this.dialogVisible = true;
    },
    closeFormDialog() {
      this.dialogVisible = false;
      this.formData = {
        id: "",
        account: "",
        password: "",
      };
      if (this.$refs.formRef) {
        this.$refs.formRef.resetFields();
      }
    },
    submitForm() {
      this.$refs.formRef.validate((valid) => {
        if (!valid) {
          return false;
        }
        this.openGoogleDialog(() => {
          const request =
            this.formTitle === "新增"
              ? api.add({
                  account: this.formData.account,
                  password: encrypt(this.formData.password),
                })
              : api.update({
                  id: this.formData.id,
                  account: this.formData.account,
                  password: encrypt(this.formData.password),
                });
          return request.then((res) => {
            if (res.code == 0) {
              this.$message.success(this.formTitle + "成功");
              this.closeFormDialog();
              this.fetchList();
            }
          });
        });
      });
    },
    openReset(row) {
      this.resetData = {
        id: row.id,
        account: row.account || "",
        password: "",
      };
      this.resetDialogVisible = true;
    },
    closeResetDialog() {
      this.resetDialogVisible = false;
      this.resetData = {
        id: "",
        account: "",
        password: "",
      };
      if (this.$refs.resetFormRef) {
        this.$refs.resetFormRef.resetFields();
      }
    },
    submitReset() {
      this.$refs.resetFormRef.validate((valid) => {
        if (!valid) {
          return false;
        }
        this.openGoogleDialog(() => {
          return api
            .resetPwd({
              id: this.resetData.id,
              password: encrypt(this.resetData.password),
            })
            .then((res) => {
              if (res.code == 0) {
                this.$message.success("重置密码成功");
                this.closeResetDialog();
                this.fetchList();
              }
            });
        });
      });
    },
    toggleLock(row) {
      this.openGoogleDialog(() => {
        const request = row.isLocked
          ? api.unlock({ id: row.id })
          : api.lock({ id: row.id });
        return request.then((res) => {
          if (res.code == 0) {
            this.$message.success("操作成功");
            this.fetchList();
          }
        });
      });
    },
    remove(row) {
      this.openGoogleDialog(() => {
        return api.remove({ id: row.id }).then((res) => {
          if (res.code == 0) {
            this.$message.success("删除成功");
            this.fetchList();
          }
        });
      });
    },
    removeGoogle(row) {
      this.openGoogleDialog(() => {
        return api.resetGoogle({ id: row.id }).then((res) => {
          if (res.code == 0) {
            this.$message.success("删除谷歌成功");
            this.fetchList();
          }
        });
      });
    },
    openGoogleDialog(action) {
      this.pendingAction = action;
      this.googleForm.googleCode = "";
      this.googleDialogVisible = true;
    },
    closeGoogleDialog() {
      this.googleDialogVisible = false;
      this.googleForm.googleCode = "";
      if (this.$refs.googleFormRef) {
        this.$refs.googleFormRef.resetFields();
      }
      this.pendingAction = null;
    },
    confirmGoogle() {
      this.$refs.googleFormRef.validate((valid) => {
        if (!valid) {
          return false;
        }
        api.checkGoogle({ googleCode: this.googleForm.googleCode }).then(() => {
          const action = this.pendingAction;
          this.closeGoogleDialog();
          if (action) {
            action();
          }
        });
      });
    },
  },
};
</script>

<style lang="less" src="../../styles/button.less" scoped></style>
